
import { Injectable } from '@angular/core';
import { ProductEntitlementsService } from './product-entitlements.service';
import { ClassEnrollmentService } from './class-enrollments.service';
import { LearnerHelperService } from './learner-helper.service';
import { NetwordDetectionService } from 'modules/app/services/network-detection.service';
import { HelperService } from './helper.service';
import { DesktopGlobalStateService } from './desktop-global-state.service';
import { DownloadHelperService } from './download-helper.service';

@Injectable()
export class LearnerDashboardService {

    private learnerDashboardDataCache = {
        classSpaces: null,
        independentEntitlements: null
    }

    constructor(
        private classEnrollmentService: ClassEnrollmentService,
        private networkService: NetwordDetectionService,
        private helperService: HelperService,
        private desktopGlobalStateService: DesktopGlobalStateService,
        private productEntitlementsService: ProductEntitlementsService,
        private downloadHelperService: DownloadHelperService,
        private learnerHelperService: LearnerHelperService,
    ) {
    }

    public setDashboardDataCache(classSpaces, independentEntitlements) {
        this.learnerDashboardDataCache = { classSpaces, independentEntitlements };
    }

    public resetDashboardDataCache() {
        this.learnerDashboardDataCache = { classSpaces: null , independentEntitlements: null };
    }

    public getDashboardDataCache() {
        return this.learnerDashboardDataCache;
    }

    /**
     * 
     * @param fetchFromServer : true means the user wants data to be fetched from server and not from local DB     * @returns 
     */
    public async getDashboardData(fetchFromServer = false) {

        if (!fetchFromServer) {
            let isFetchRequired = false;
            let dashboardDataCache = this.getDashboardDataCache();
            for (let key in dashboardDataCache) {
                if (!dashboardDataCache[key]) {
                    isFetchRequired = true;
                }
            }
            if (!isFetchRequired) {
                return dashboardDataCache;
            }
        }

        let fetchedFromServerOnce = this.desktopGlobalStateService.getState({propName: DesktopGlobalStateService.STATE_PROPS.ENTITLEMENTS});
        let isOnline = await this.networkService.isOnline(true);

        if (isOnline && !fetchedFromServerOnce) {
            await this.learnerHelperService.getLearnerSpacesAndEntitlementsDataFromAPI().toPromise();
            
            // setting the flag to signify that student's spaces and entitlements have been fetched from server
            this.desktopGlobalStateService.updateState(DesktopGlobalStateService.STATE_PROPS.ENTITLEMENTS, true);
            this.desktopGlobalStateService.updateState(DesktopGlobalStateService.STATE_PROPS.SPACES, true);
        }

        //putting delay provision 
        // otherwise fetchLearnerEntitlements was being called before the services were instantiated
        // as services are being instantiated with a delay of 100ms
        // TODO: Find a final alternative fix for this
        if(!isOnline){
            await new Promise((res,rej)=>{
                setTimeout(res,300)
            })
        }
        let entitlementBundles = await this.productEntitlementsService.fetchLearnerEntitlements();
        let classSpaces = await this.classEnrollmentService.fetchLearnerClasses();

        return { entitlementBundles, classSpaces };
    }

    tranformDashboardData(classSpaces, entitlementBundles) {
        let entitlementBundleInClasses = [];
        classSpaces.forEach(space => {
            space.classes.forEach(classData => {
                classData.bundles.forEach(classDataBundle => {
                    let indexInEntitlementBundle = entitlementBundles.findIndex(entitlementBundle => entitlementBundle['bundle-code'] == classDataBundle['bundle-code']);
                    if (indexInEntitlementBundle > -1) {
                        //Set products equal to entitled Products
                        classDataBundle.products = entitlementBundles[indexInEntitlementBundle].products;
                        
                        let activeProducts = classDataBundle && classDataBundle.products && classDataBundle.products.filter((product) => {

                            let isProductValid = this.helperService.isProductActive(product) && (!product.isExpired || (product.isExpired && this.downloadHelperService.getDownloadedInfoForUser(product['dls-product'].code)));
                            if (product.isExpired && this.downloadHelperService.getPausedInfoForUser(product['dls-product'].code)) {
                                this.downloadHelperService.removeDownload({
                                    productCode: product['dls-product'].code,
                                    status: 'inProcess',
                                    product: product
                                });
                            }
                            return isProductValid;

                        });

                        // keeping only active products in the bundle
                        classDataBundle.products = activeProducts;
                        
                        entitlementBundleInClasses.push(indexInEntitlementBundle);
                    } else {
                        classDataBundle.products = [];
                    }
                });
                //Remove bundles having no products
                classData.bundles = classData.bundles.filter((bundle) => bundle.products && bundle.products.length)
            });
            //Remove classes which don't have any bundles
            space.classes = space.classes.filter(classData=> classData.bundles && classData.bundles.length );
        });

        //Remove Spaces which don't have any class
        classSpaces = classSpaces.filter((space) => space.classes && space.classes.length)

        //Remove entitlements which are already Included in Class
        entitlementBundles = entitlementBundles.filter((bundle, index) => {
            if(entitlementBundleInClasses.indexOf(index) < 0){

                let activeProducts = bundle.products.filter((product) => {

                    let isProductValid = this.helperService.isProductActive(product) && (!product.isExpired || (product.isExpired && this.downloadHelperService.getDownloadedInfoForUser(product['dls-product'].code)));
                    if (product.isExpired && this.downloadHelperService.getPausedInfoForUser(product['dls-product'].code)) {
                        this.downloadHelperService.removeDownload({
                            productCode: product['dls-product'].code,
                            status: 'inProcess',
                            product: product
                        });
                    }
                    return isProductValid;
                });

                // keeping only active products in the bundle
                bundle.products = activeProducts;

                // sending true only bundle has at least one products
                return bundle.products.length;
            }
        });

        if(entitlementBundles && this.downloadHelperService.bookIDtoSpaceIDmap.has('privateSpace')){
            entitlementBundles.forEach(entitlement => {
                entitlement.products.forEach(product => {   
                    this.downloadHelperService.bookIDtoSpaceIDmap.set(product['dls-product'].code, this.downloadHelperService.bookIDtoSpaceIDmap.get('privateSpace'));
                });
            });
        }

        return {
            classSpaces: classSpaces,
            independentEntitlements: entitlementBundles
        }
    }
}